const POLYNOMIAL = 0x1021;
const INITIAL_VALUE = 0xffff;

export function crc16(payload: string): string {
  let crc = INITIAL_VALUE;

  for (let i = 0; i < payload.length; i++) {
    crc ^= payload.charCodeAt(i) << 8;

    for (let bit = 0; bit < 8; bit++) {
      crc = (crc & 0x8000) !== 0 ? (crc << 1) ^ POLYNOMIAL : crc << 1;
      crc &= 0xffff;
    }
  }

  return crc.toString(16).toUpperCase().padStart(4, '0');
}
